import { defineComponent } from "vue";
import TariffOverviewCard from "@/components/tariff-overview-card";
import OrderFormExistingClient from "@/components/order-form-existing-client";
import GiftCountdownCard from "@/components/gift-countdown-card";
import OrderFormNewClient from "@/components/order-form-new-client";

import giftSectionImage from "@/assets/img/sim/hbo-second.png";

export default defineComponent({
  template: `
      <div class="row">
      <div class="col">
        <TariffOverviewCard :tariff="this.program" :includeIptv="this.includeIptv" :iptvPrice="this.iptvPrice" />
      </div>
      <div class="col">
        <OrderFormExistingClient
            @stepChanged="this.handleStepChange"
            :program="this.program"
            :includeIptv="this.includeIptv"
            :iptvPrice="this.iptvPrice"
            :gtm-event-prefix="this.gtmEventPrefix"
            v-if="this.isClient"
        ></OrderFormExistingClient>
        <OrderFormNewClient
            @stepChanged="this.handleStepChange"
            :program="this.program"
            :includeIptv="this.includeIptv"
            :iptvPrice="this.iptvPrice"
            :gtm-event-prefix="this.gtmEventPrefix"
            v-if="!this.isClient"
        ></OrderFormNewClient>
      </div>
      </div>
      <div class="gift-section" v-if="this.isClient && Date.now() < new Date('2023-04-01')">
      <div class="gift-section-left">
        <h1 class="gift-heading">Získejte slevu a dárek</h1>
        <GiftCountdownCard :endTimestamp="this.offerEndsAt"></GiftCountdownCard>
        <h4 class="gift-limited-time">Časově omezená nabídka</h4>
      </div>

      <div class="gift-section-right">
        <p>
          Objednejte si mobilní tarif a získejte od nás slevu + speciální dárek.
        </p>
        <!--
        <img
            class="gift-section-img"
            src="@/assets/disney-hbo.jpeg"
            alt=""
            height="80"
        />
        -->
        <h4 class="gift-section-gift-heading">Máte-li od nás televizi, získáte:</h4>
        <ul class="styled-list">
          <li>
          <strong>Jednorázová sleva ve výši 200 Kč</strong> za každou
            objednanou SIM kartu
          </li>
          <li>
          <strong>Dárek za 265 Kč:</strong> kanály HBO a Disney na 1 měsíc
            ZDARMA
          </li>
        </ul>
        <!--
        <img
            class="gift-section-img"
            :src="giftSectionImage"
            alt=""
            height="100"
        />
        -->
        <h4 class="gift-section-gift-heading">Máte-li od nás pouze internet, získáte:</h4>
        <ul class="styled-list">
          <li><strong>Jednorázová sleva ve výši 200 Kč</strong> za každou
            objednanou SIM kartu
          </li>
          <li><strong>Dárek:</strong> PODA net.TV + HBO kanály v hodnotě 250 Kč na
            1 měsíc ZDARMA
          </li>
        </ul>
      </div>
      </div>

      <slot></slot>
    `,
  name: "TariffOrderForm",
  props: {
    program: {
      type: Object,
    },
    isClient: {
      type: Boolean,
    },
    includeIptv: {
      type: Boolean,
      default: false,
      required: false,
    },
    iptvPrice: {
      type: Number,
      default: 0,
      required: false,
    },
    gtmEventPrefix: {
      type: String,
      required: false,
      default: "sim_order_form_",
    },
  },
  emits: ["stepChanged"],
  components: {
    TariffOverviewCard,
    OrderFormExistingClient,
    OrderFormNewClient,
    GiftCountdownCard,
  },
  methods: {
    async handleStepChange(payload: any) {
      this.$emit("stepChanged", payload);
    },
  },
  computed: {
    offerEndsAt() {
      const now = new Date();
      // localstorage not available
      if (typeof localStorage === "undefined") {
        return new Date(now.getTime() + 86400000).getTime();
      }
      // try to load offer end ts from localStorage
      const expOfferEndsAt = parseInt(localStorage.getItem("volani.sim.expOfferEndsAt"));
      if (expOfferEndsAt && new Date(expOfferEndsAt).getTime() > now.getTime() + 5 * 60 * 1000) {
        // Countdown end already set up and is at least 10min in the future
        return expOfferEndsAt;
      }
      // Countdown end not defined or in the past or too close to end
      const offerEndsAt = new Date(now.getTime() + 86400000).getTime();
      localStorage.setItem("volani.sim.expOfferEndsAt", offerEndsAt.toString());
      return offerEndsAt;
    },
  },
  data() {
    return {
      giftSectionImage: giftSectionImage,
    };
  },
});
